import Footer from '../components/Footer.jsx';
import PublicHeader from '../components/PublicHeader.jsx';
import { useTitle } from '../lib/useTitle.js';
import { useMetaTags } from '../lib/useMetaTags.js';

export default function Privacy() {
  useTitle('Privacy Policy');
  useMetaTags({
    description: 'TrainForge privacy policy: what data the app collects (workouts, body measurements, food photos, nutrition logs), how it is used, and how to request deletion.',
    ogTitle: 'TrainForge privacy policy',
    ogDescription: 'What TrainForge collects, how it is used, and how to delete your data.',
    ogType: 'website',
    canonical: 'https://mytrainforge.com/privacy',
  });
  return (
    <div>
      <PublicHeader />
      <div className="shell" style={{ maxWidth: 640 }}>
      <h1>Privacy Policy</h1>
      <div style={{ fontSize: 14, lineHeight: 1.7, color: 'var(--text-dim)' }}>
        <h2 style={{ color: 'var(--text)' }}>Data We Collect</h2>
        <ul>
          <li>Name and email address</li>
          <li>Body measurements (weight, body-fat %, skeletal muscle)</li>
          <li>Workout history (exercises, sets, reps, weight lifted)</li>
          <li>Profile information (age, height, goals, injuries, food allergies, diet type)</li>
          <li>Booking and session records</li>
          <li>Food photos and nutrition logs</li>
          <li>Equipment and training location preferences</li>
        </ul>

        <h2 style={{ color: 'var(--text)' }}>How We Use It</h2>
        <p>To provide personalized training programs, nutrition tracking, and macro recommendations. AI features send your profile data and food photos to OpenAI for processing. No data is retained by OpenAI beyond the request. Food photos may be stored for your personal log and trainer review.</p>

        <h2 style={{ color: 'var(--text)' }}>Who Has Access</h2>
        <p>Your gym's owners and your assigned trainer can view your workout history and measurements to provide coaching. Other members cannot see your data. Your data is never sold to third parties.</p>

        <h2 style={{ color: 'var(--text)' }}>Data Storage</h2>
        <p>Stored securely on Google Cloud (Firebase) with encryption at rest and in transit. Servers located in the United States (Columbus, OH region).</p>

        <h2 style={{ color: 'var(--text)' }}>Your Rights</h2>
        <p>You may request a full export of your data or deletion of your account at any time by contacting the gym owner or emailing support. We will process deletion requests within 30 days.</p>

        <h2 style={{ color: 'var(--text)' }}>Cookies & Analytics</h2>
        <p>We use Firebase Analytics to track app usage (page views, feature adoption). No advertising cookies are used. You may opt out by disabling analytics in your browser settings.</p>

        <p style={{ color: 'var(--text-muted)', marginTop: 32, fontSize: 11 }}>Privacy Policy version 1 · Last updated May 2026</p>
      </div>
      <Footer />
      </div>
    </div>
  );
}
